import { render, staticRenderFns } from "./AutomateCard.vue?vue&type=template&id=083cd23c&scoped=true&"
import script from "./AutomateCard.vue?vue&type=script&lang=js&"
export * from "./AutomateCard.vue?vue&type=script&lang=js&"
import style0 from "./AutomateCard.vue?vue&type=style&index=0&id=083cd23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cd23c",
  null
  
)

export default component.exports